import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/navigation';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
                  <i className="ri-compass-3-fill"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">
                  91n.con 导航
                </span>
              </div>
              <p className="text-sm leading-relaxed text-background-50/60">
                提供91n.con最新可用地址、访问指引及常见问题解答，帮助用户安全高效直达目标页面。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {navLinks.slice(0, 4).map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">安全提示</h4>
              <ul className="space-y-2.5 text-sm text-background-50/60">
                <li>认准官方域名：91n.con</li>
                <li>谨防仿冒钓鱼网站</li>
                <li>勿泄露账号密码信息</li>
                <li>通过本页获取最新地址</li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-background-50/60">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  support@91n.con
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-primary-400"></i>
                  工作日24小时内回复
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-primary-400"></i>
                  官方认证导航平台
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/10">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-sm text-background-50/40">
                &copy; {new Date().getFullYear()} 91n.con 官方入口导航 - 版权所有
              </p>
              <div className="flex items-center gap-6 text-sm text-background-50/40">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
                <span>更新于 2026-08-05</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}